import type { BlogPost } from '../types';

export const post: BlogPost = {
  "id": "304",
  "slug": "spot-chile-from-satellite-imagery",
  "title": "How to Recognise Chile in Satellite Images",
  "excerpt": "Chile follows the Pacific side of the Andes.",
  "date": "2026-04-05",
  "category": "Geography",
  "series": "Spot the Country",
  "image": "/blog-images/chile.jpg",
  "readTime": "1 min",
  "content": [
    {
      "type": "paragraph",
      "text": "Chile follows the Pacific side of the Andes. The dry north includes the Atacama, the central region has cultivated valleys, and southern Chile breaks into channels, islands, and fjords. A close crop may show only one of these settings, so there is no single colour that represents the whole country."
    },
    {
      "type": "heading",
      "text": "A coast beside the Andes"
    },
    {
      "type": "paragraph",
      "text": "Compare northern and southern Chile. Trace the continuous coast in the north and the fragmented coast in the south before studying individual valleys."
    },
    {
      "type": "heading",
      "text": "Similar landscapes across borders"
    },
    {
      "type": "paragraph",
      "text": "Peru also has a desert coast backed by the Andes. Patagonia extends into Argentina, and glaciated coastlines can resemble Norway or New Zealand. The relative positions of coast and mountains help more than the presence of snow alone."
    }
  ],
  "imageAlt": "Chile regional satellite composite with shaded relief",
  "imageCaption": "NASA Earth Observatory / MODIS, August 2004. Regional composite with shaded relief and bathymetry; it shows landforms, not political boundaries or current conditions.",
  "sources": [
    {
      "title": "NASA: Blue Marble Next Generation (image source)",
      "url": "https://science.nasa.gov/earth/earth-observatory/blue-marble-next-generation/"
    }
  ]
};
